import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home.jsx';
import DomoticsServices from './pages/Servicios.jsx';
import Products from './pages/Productos.jsx';
import SeccMarcas from "./Components/Secc_marcas.jsx";
import RedesNetworking from './pages/RyN';
import SistemasPOS from './pages/pos.jsx';
import IntelligentParking from './pages/parqueaderosInteligentes.jsx';
import SpecializedSoftware from './pages/licenciamiento-software.jsx';
import SolarEnergy from './pages/solar-systems.jsx';
import SecurityDoors from './pages/puertasseguridad.jsx';
import DigitalSignage from './pages/pantallas-señalización.jsx';
import SecurityCCTV from './pages/Security-Cctv.jsx';
import ComputoVideoconferencia from './pages/computoyvideoconferencia.jsx';
import NosotrosPage from './pages/Nosotros.jsx';
import Partners from './pages/Partners.jsx';
import Automatizacion from './pages/Automatizacion.jsx';
import PLAutomatizacion from './pages/PLAutomatizacion.jsx';


const AppRoutes = () => {
  return (
    <Router>
      <div style={{ minHeight: 'calc(100vh - 100px)' }}>
        {/* Ajusta el minHeight para dejar espacio al footer */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="Servicios" element={<DomoticsServices />} />
          <Route path="Productos" element={<Products />} />
          <Route path="Nosotros" element={<NosotrosPage />} />
          <Route path="/RedesNetworking" element={<RedesNetworking />} />
          <Route path="/SistemasPOs" element={<SistemasPOS />} />
          <Route path="/IntelligentParking" element={<IntelligentParking/>} />
          <Route path="/licenciamiento-software" element={<SpecializedSoftware/>} />
          <Route path="/SolarSystems" element={<SolarEnergy/>} />
          <Route path="/Puertas-Seguridad" element={<SecurityDoors/>} />
          <Route path="/Pantallas-Señalización" element={<DigitalSignage/>} />
          <Route path="/SecurityCctv" element={<SecurityCCTV/>} />
          <Route path="/ComputoVideoConferencia" element={<ComputoVideoconferencia/>} />
          <Route path="/Partners" element={<Partners/>} />
          <Route path="/Automatizacion" element={<Automatizacion/>} />
          <Route path="/PLAutomatizacion" element={<PLAutomatizacion/>} />


<Route path="/secc_marcas" element={<SeccMarcas />} />
        </Routes>
      </div>
    </Router>
  );
};

export default AppRoutes;
